import endpoints from "../../utility/endpoints";

const createSearchSuggestion = (data) => {
  const searchSuggestion = {
    Products: [],
    Bots: [],
    "Employee Twins": [],
  };

  if (data?.products?.length > 0) {
    for (let item of data?.products?.slice(0, 10)) {
      if (item?.url) {
        searchSuggestion.Products.push({
          ...item,
          link: `${endpoints.redirectUriLogin}/product_details/${item?.url}?id=${item?.id}`,
        });
      }
    }
  }

  if (data?.bots?.length > 0) {
    for (let item of data?.bots?.slice(0, 10)) {
      searchSuggestion.Bots.push({
        ...item,
        link: `${endpoints.redirectUriLogin}botDetails?botID=${window.btoa(item?.id)}`,
      });
    }
  }

  if (data?.employeeTwins?.length > 0) {
    for (let item of data?.employeeTwins?.slice(0, 10)) {
      searchSuggestion["Employee Twins"].push({
        ...item,
        link: `${endpoints.redirectUriLogin}/Employeetwinsdetail?empTwinId=${item?.id}&name=${item?.name}&leadPlatform=${item?.leadPlatform}`,
      });
    }
  }

  return searchSuggestion;
};

export default createSearchSuggestion;
